import { useLocalizedText } from '../localizedText';
import { WizardProps } from '@amzn/awsui-components-react/polaris/wizard';

// These functions provide a default pattern for i18n strings from Cloudscape components
// Default values are stored in src/localization/{lng}.json, but can be overriden by specific prefixes or namespaces
// ONLY override the SPECIFIC strings that need to change, and leave the strings where you wish to use the defaults as undefined in the prefix

export function useWizardStrings(
  wizardPrefix: string,
  namespaces: string[] = ['translation']
): WizardProps.I18nStrings {
  const { t } = useLocalizedText(namespaces);

  return {
    stepNumberLabel: (stepNumber) =>
      t([`${wizardPrefix}.stepNumberLabel`, `wizard.stepNumberLabel`], { stepNumber }),
    collapsedStepsLabel: (stepNumber, stepsCount) =>
      t([`${wizardPrefix}.collapsedStepsLabel`, `wizard.collapsedStepsLabel`], {
        stepNumber,
        stepsCount,
      }),
    skipToButtonLabel: (step, stepNumber) =>
      t([`${wizardPrefix}.skipToButtonLabel`, `wizard.skipToButtonLabel`], { title: step.title }),
    navigationAriaLabel: t([`${wizardPrefix}.navigationAriaLabel`, `wizard.navigationAriaLabel`]),
    cancelButton: t([`${wizardPrefix}.cancelButton`, `wizard.cancelButton`]),
    previousButton: t([`${wizardPrefix}.previousButton`, `wizard.previousButton`]),
    // nextButton intentionally reads only the static `wizard.nextButton`, not `${wizardPrefix}.nextButton`.
    // A wizard that wants a dynamic label (e.g. "Next - {title}") stores it under its prefix key AND
    // sets it per-step in the caller with the title arg (see coordinatorAttendance / createEvent /
    // editEvent). Reading the prefix key here would format that arg-bearing string with no title and
    // throw formatjs MISSING_VALUE, so the default stays the plain static label.
    nextButton: t([`wizard.nextButton`]),
    submitButton: t([`${wizardPrefix}.submitButton`, `wizard.submitButton`]),
    optional: t([`${wizardPrefix}.optional`, `wizard.optional`]),
  };
}
